module.exports = __webpack_public_path__ + "media/images/icons/arrow_up-4d75bf22469a08ffe4195a3e8cb4949c.svg";